import OtherPageFormat from "../components/OtherPageFormat";

const LoginPage = () => {
  return (
    <div className="bg-red-200 h-4/5">
      <OtherPageFormat title={"Login"} />
    </div>
  );
};

export default LoginPage;
